import { PostIncrementInDto, GetIncrementOutDto } from "../../../types/post-views.dto";

export const GET_POST_INCREMENT = "GET_POST_INCREMENT";
export const GET_POST_INCREMENT_SUCCESS = "GET_POST_INCREMENT_SUCCESS";
export const GET_POST_INCREMENT_ERROR = "GET_POST_INCREMENT_ERROR";
export const RESET_POST_INCREMENT = "RESET_POST_INCREMENT";

export interface GetPostIncrement {
  type: typeof GET_POST_INCREMENT;
  payload: GetIncrementOutDto;
}

export interface GetPostIncrementSuccess {
  type: typeof GET_POST_INCREMENT_SUCCESS;
  payload: PostIncrementInDto;
}

export interface GetPostIncrementError {
  type: typeof GET_POST_INCREMENT_ERROR;
  payload: string | boolean;
}

export interface ResetPostIncrement {
  type: typeof RESET_POST_INCREMENT;
  payload: null;
}

export interface State {
  data: PostIncrementInDto | null;
  states: {
    success: boolean;
    loading: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  data: null,
  states: {
    success: false,
    loading: false,
    error: false,
  },
};

export type Actions = GetPostIncrement | GetPostIncrementSuccess | GetPostIncrementError | ResetPostIncrement;

